import { useQuery } from "@tanstack/react-query";
import { CostCenterAPI } from "api";

const fetchCostCenter = () => {
  return CostCenterAPI.get();
};
export const useFetchCostCenter = () => {
  return useQuery({
    queryKey: ["cost-center"],
    queryFn: fetchCostCenter,
    staleTime: 5000,
    refetchOnWindowFocus: false, // Disable refetching on window focus
  });
};
